/* eslint-disable @typescript-eslint/naming-convention */
export enum ErrorTypeEnum {
    ImageFileType = 'ImageFileType',
    ImagefileSize = 'ImagefileSize',
}
